module.exports = __webpack_public_path__ + "img/levi.8251bf4.png";